// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const Home_Filled_Corner0_Rounded = createSinglePathSVG({
  path: 'M21 11.25v9a.75.75 0 0 1-.75.75H15a.75.75 0 0 1-.75-.75v-4.875a.375.375 0 0 0-.375-.375h-3.75a.375.375 0 0 0-.375.375v4.875A.75.75 0 0 1 9 21H3.75a.75.75 0 0 1-.75-.75v-9a1.5 1.5 0 0 1 .44-1.06l7.5-7.5a1.5 1.5 0 0 1 2.12 0l7.5 7.5a1.5 1.5 0 0 1 .44 1.06Z',
  viewBox: '0 0 24 24',
  glyph: 'Home_Filled_Corner0_Rounded',
})

export const Home_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'm20.56 10.189-7.5-7.5a1.5 1.5 0 0 0-2.12 0l-7.5 7.5A1.5 1.5 0 0 0 3 11.25v9a.75.75 0 0 0 .75.75h6a.75.75 0 0 0 .75-.75V15h3v5.25a.75.75 0 0 0 .75.75h6a.75.75 0 0 0 .75-.75v-9a1.5 1.5 0 0 0-.44-1.061ZM19.5 19.5H15v-5.25a.75.75 0 0 0-.75-.75h-4.5a.75.75 0 0 0-.75.75v5.25H4.5v-8.25l7.5-7.5 7.5 7.5Z',
  viewBox: '0 0 24 24',
  glyph: 'Home_Stroke2_Corner0_Rounded',
})

export const Home_Stroke2_Corner2_Rounded = createSinglePathSVG({
  path: 'm20.56 10.189-7.5-7.5a1.5 1.5 0 0 0-2.12 0l-7.5 7.5A1.5 1.5 0 0 0 3 11.25v9a.75.75 0 0 0 .75.75h6a.75.75 0 0 0 .75-.75V15h3v5.25a.75.75 0 0 0 .75.75h6a.75.75 0 0 0 .75-.75v-9a1.5 1.5 0 0 0-.44-1.061ZM19.5 19.5H15v-5.25a.75.75 0 0 0-.75-.75h-4.5a.75.75 0 0 0-.75.75v5.25H4.5v-8.25l7.5-7.5 7.5 7.5Z',
  viewBox: '0 0 24 24',
  glyph: 'Home_Stroke2_Corner2_Rounded',
})

export const HomeOpen_Filled_Corner0_Rounded = createSinglePathSVG({
  path: 'M22.5 19.5H21v-6.75l.22.22a.751.751 0 0 0 1.06-1.064L13.06 2.69a1.5 1.5 0 0 0-2.12 0l-9.22 9.217a.75.75 0 0 0 1.06 1.06L3 12.75v6.75H1.5a.75.75 0 0 0 0 1.5h21a.75.75 0 0 0 0-1.5Zm-8.25 0h-4.5V15a.375.375 0 0 1 .375-.375h3.75a.375.375 0 0 1 .375.375Z',
  viewBox: '0 0 24 24',
  glyph: 'HomeOpen_Filled_Corner0_Rounded',
})

export const HomeOpen_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M22.5 19.5H21v-6.75l.22.22a.751.751 0 0 0 1.06-1.064L13.06 2.69a1.5 1.5 0 0 0-2.12 0l-9.22 9.217a.75.75 0 0 0 1.06 1.06L3 12.75v6.75H1.5a.75.75 0 0 0 0 1.5h21a.75.75 0 0 0 0-1.5Zm-18-8.25 7.5-7.5 7.5 7.5v8.25H15v-5.25a.75.75 0 0 0-.75-.75h-4.5a.75.75 0 0 0-.75.75v5.25H4.5Zm9 8.25h-3V15h3Z',
  viewBox: '0 0 24 24',
  glyph: 'HomeOpen_Stroke2_Corner0_Rounded',
})
